import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--password-change"
export default class extends Controller {
    connect() {
        console.log('PasswordChangeController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-account-password-change');
        if (!form) {
            console.error('Password change form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'user[password]': {
                    validators: {
                        notEmpty: {
                            message: 'The current password is required'
                        }
                    }
                }, 'user[pw_new]': {
                    validators: {
                        notEmpty: {
                            message: 'Password is required'
                        }, stringLength: {
                            min: 6, message: 'Password must be at least 6 characters long'
                        }
                    }
                }, 'user[pw_new_confirm]': {
                    validators: {
                        notEmpty: {
                            message: 'Password confirmation is required'
                        }, identical: {
                            compare: function () {
                                return form.querySelector('[name="user[pw_new]"]').value;
                            }, message: 'The password and its confirmation are not the same'
                        }
                    }
                }
            }, plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }), submitButton: new plugins.SubmitButton(), bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.form-floating', eleInvalidClass: 'is-invalid', eleValidClass: 'is-valid'
                })
            }
        })
            .on('core.form.valid', function (e) {
                // Use Turbo's submit method instead of direct form submission
                // This allows Turbo to handle the submission with turbo_stream format
                const submitEvent = new Event('submit', {bubbles: true, cancelable: true});
                form.dispatchEvent(submitEvent);
            })
            .on('core.form.invalid', function (e) {
                // console.log('Form is invalid!');
            });

        // Revalidate password_confirmation when password changes
        form.querySelector('[name="user[pw_new]"]').addEventListener('input', () => {
            this.validation.revalidateField('user[pw_new_confirm]');
        });
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }
    }
}
